import { transformToPeriod } from '../Period/PeriodTransformers'
import { ShiftPlanning, ShiftPlanningV3Resource } from './ShiftPlanning'

export const transformShiftPlanningV3 = (resource: ShiftPlanningV3Resource): ShiftPlanning => ({
    ...resource,
    period: transformToPeriod(new Date(resource.start), new Date(resource.end)),
})
